import { t } from 'i18next';
import { SettingToggleRow } from '../../../../components/setting-toggle-row';
import type { I18nPrefix } from '../../../../i18n/prefix';
import { DOCS_URLS, TEMPLATE_ID_OPTIONS, type TemplateId } from '../../constants';
import { useStorefrontOptionsControls } from '../../context/storefront-options-context';
import { OptionsCard } from '../options-card';

const CARD =
  'features:storefront_options.pages.storefront_options_page.cards.slots' satisfies I18nPrefix;

export function SlotsCard() {
  const { options, setDisplay } = useStorefrontOptionsControls();
  const { display } = options;

  function setSlotVisibility(slot: TemplateId, visible: boolean) {
    const selectedSlots = new Set(display.showSlots);

    if (visible) {
      selectedSlots.add(slot);
    } else {
      selectedSlots.delete(slot);
    }

    setDisplay(
      'showSlots',
      TEMPLATE_ID_OPTIONS.map(({ value }) => value).filter((value) => selectedSlots.has(value)),
    );
  }

  return (
    <OptionsCard
      title={t(`${CARD}.title`)}
      subtitle={t(`${CARD}.subtitle`)}
      learnMoreUrl={DOCS_URLS.slots}
    >
      <div className="flex flex-col gap-3">
        {TEMPLATE_ID_OPTIONS.map((slot) => (
          <SettingToggleRow
            key={slot.value}
            label={slot.label}
            description={slot.value}
            mono
            truncate
            checked={display.showSlots.includes(slot.value)}
            onChange={(checked) => setSlotVisibility(slot.value, checked)}
          />
        ))}
      </div>
    </OptionsCard>
  );
}
